import React from 'react';

import lang from '../../lib/language';

import iconClose from '../../assets/img/close-line.svg';
import IconAlert from '../../assets/img/icon-exclamation-mark-warning.svg';
import { useIsMobile } from '../../hooks';
import BaseModal from '../BaseModal/BaseModal';
import { ButtonTypesEnum } from '../Button/Button.types';
import ClickableImage from '../ClickableImage/ClickableImage';
import { Button } from '../index';

import styles from './ShortSellOrderPlace.module.scss';

type Props = {
  processModal: () => void;
  toggleModal: () => void;
};

const ShortSellOrderPlace = ({ toggleModal, processModal }: Props) => {
  const isMobile = useIsMobile();

  return (
    <BaseModal
      isOpen
      customStyle={
        isMobile
          ? {
            paddingBottom: 32,
            margin: 0,
            width: window.innerWidth,
            marginTop: window.innerHeight / 3.6,
            position: 'fixed',
            alignSelf: 'flex-end',
          }
          : undefined
      }
    >
      <div className={styles.titleAndClose}>
        <h6 className={styles.title}>{lang.commonTradingShortSellDialog()}</h6>
        {isMobile && <ClickableImage src={iconClose} onClick={toggleModal} />}
      </div>
      <div className={styles.content}>
        <div className={styles.generalInfo}>{lang.commonTradingShortSellDialogDescription()}</div>
        <div className={styles.timeAlert}>
          <div className={styles.reportsIconWrapper}>
            <img className={styles.reportsIcon} src={IconAlert} alt="short sell open hours alert" />
          </div>
          <span className={styles.info}>{lang.commonTradingShortSellDialogDescriptionWeb()}</span>
        </div>
      </div>
      <div className={styles.actions}>
        <Button fullWidth className={styles.okBtn} onClick={processModal}>
          {lang.commonOkay()}
        </Button>
        <Button fullWidth variant={ButtonTypesEnum.Tertiary} className={styles.cancelBtn} onClick={toggleModal}>
          {lang.commonCancelMultiple()}
        </Button>
      </div>
    </BaseModal>
  );
};

export default ShortSellOrderPlace;
